export default {
  summary: {
    delivery: 'Toimitus: Lahjakortti PDF-muodossa sähköpostitse',
  },
};
